import React from 'react';

import { useAssistant } from './AssistantProvider';
import Launcher from './Launcher';
import Panel from './Panel';
import AssistantErrorBoundary from './ErrorBoundary';

// NOTE: assistant.css is a global stylesheet imported once from pages/_app
// (Next.js Pages Router only allows global CSS imports there).

/*
 * Business Radar AI Assistant — launcher FAB + docked right-side chat panel.
 * Rendered inside <AssistantProvider> in the authenticated app shell
 * (src/Layout/index.tsx) so the shell can reserve width in pinned mode.
 * Transport rides the existing alerts websocket (CHAT_EVENT) plus REST send.
 */
const Assistant = () => {
  const { forbidden } = useAssistant();
  // No access (403 from the backend): render nothing.
  if (forbidden) return null;
  return (
    <div className="bra-root">
      <Launcher />
      <AssistantErrorBoundary>
        <Panel />
      </AssistantErrorBoundary>
    </div>
  );
};

export default Assistant;
